import { not, readOnly } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  countryCode: validator('presence', true),
  targetUrl: [
    validator('presence', {
      disabled: not('model.isCustom'),
      presence: readOnly('model.isCustom'),
    }),
    validator('format', {
      disabled: readOnly('model.isPattern'),
      regex: /https?:\/\/[a-z0-9-.]+\.[a-z0-9-.]+\/?.*/,
    }),
  ],
  urlType: validator('presence', true),
});

export default class ShortUrlTargetModel extends Model.extend(Validations) {
  @attr('boolean', { defaultValue: true }) appendUtm;
  @attr('string') countryCode;
  @attr('string') urlType;
  @attr('string') targetUrl;

  // CMS fields
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr('number') position;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Relations
  @belongsTo('link-pattern', { async: true, inverse: null }) linkPattern;
  @belongsTo('short-url', { async: true, inverse: 'targets' }) shortUrl;

  // Getter and setter
  get displayLabel() {
    return this.targetUrl;
  }

  get isPattern() {
    return this.urlType === 'pattern';
  }

  get isCustom() {
    return this.urlType === 'custom';
  }
}
